module.exports = __webpack_public_path__ + "img/bg_kuaqu.758f5dfd.png";